import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import store from '@state/store.js'
import config from '@common/config.js'

export default () => {
  return new HubConnectionBuilder()
    .withUrl(config.get('signalR.endpoint'), {
      skipNegotiation: false,
      transport: 1,
      accessTokenFactory: () => store.getters['signalr/getAccessToken'],
    })
    .configureLogging(LogLevel.Information)
    .build()
}
